import React from 'react';
import { Divider } from '@mui/material';
import FieldInput from './FieldInput';
import { FieldSelect } from './FieldSelect';
import FormRow from './row';
import FieldCheckbox from './FieldCheckbox';
import { eventPercentageList, emailRatingList } from './constants';

export default function FormCommunityEngagement() {
  return (
    <>
      <FormRow count={2}>
        <FieldInput
          type="numeric"
          name="communityEngagementScore"
          label="Community Engagement Score"
        />
      </FormRow>

      <Divider />

      <FieldCheckbox name="isEmailSubscriber" text="Email Subscriber" />

      <FormRow count={2}>
        <FieldSelect
          name="emailRating"
          label="Email Rating"
          options={emailRatingList}
        />
        <FieldSelect
          name="emailOpens"
          label="Emails Opened"
          subLabel="Last 5"
          options={emailRatingList}
        />
      </FormRow>

      <Divider />

      <FieldCheckbox name="isInFacebookGroup" text="Facebook Group Member" />
      <FieldCheckbox name="isInstagramFollower" text="Instagram Follower" />

      <FormRow count={2}>
        <FieldInput name="eventsAttended" label="Events Attended" />
        <FieldSelect
          name="eventAttendancePercent"
          label="Events Attended"
          subLabel="%"
          options={eventPercentageList}
        />
      </FormRow>

      <Divider />

      <FieldCheckbox name="thirtyDayInquiry" text="30 Day Inquiry" />

      <FieldCheckbox name="sixtyDayInquiry" text="60 Day Inquiry" />
    </>
  );
}
